import React, { useEffect, useState } from "react";
import user from "../../assets/images/users/user-dummy-img.jpg";
import logo from "../../assets/images/logo-dark-esg.png";
import esglogonew from "../../assets/images/ESGDhrishti.png";
import whiteLogo from "../../assets/images/logo-icon.png";
import { Link, useNavigate } from "react-router-dom";
import useStore from "../../hooks/useStore";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { Offcanvas } from "react-bootstrap";
import Sidebar from "../sidebar";
import { setLocalStorage } from "../../helpers/localStorage";
import axios from "axios";

function Header() {
  const {
    companyStore: {
      getAllCompanyData,
      companyData,
      setCatId,
      catId,
      removeCompanyData,
      companyUnit,
      setUnit,
    },
    userStore: { userData, fetchEmployeeKpis },
    dashboardStore: { showAll, setShowAll },
  } = useStore();
  const headerCategory = toJS(companyData);
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  const [showAllUnitsData, setShowAllUnitsData] = useState(false);
  const [showUnit, setShowUnit] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);

  const {
    userStore: { logoutUser, isAdminLoggedIn, isLoggedIn,token,logoutSuperAdmin },
  } = useStore();

  const [showSidebar, setShowSidebar] = useState(false);
  const [showRightSidePanel, setShowRightSidePanel] = useState(false);

  const handleProfileDropdown = () => {
    setShowProfile(!showProfile);
  };
  const handleShowAllUnitsData = (e) => {
    setShowAllUnitsData(!showAllUnitsData);
    setShowAll(e.target.checked);
    setShowUnit((prev) => !prev);
  };
  useEffect(
    () => () => {
      setLocalStorage("showAllUnit", false);
    },
    []
  );
  const logoutHandler = async () => {
    try {
      if (isAdminLoggedIn) {
        navigate("/admin");
        logoutSuperAdmin();
      }
      if (isLoggedIn) {
        navigate("/company");
        await logoutUser();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAllCompanyData();
    // eslint-disable-next-line
  }, []);

  const handleChange = (event) => {
    localStorage.setItem("companyUnit", event.target.value);
    setUnit(event.target.value);
    setShowUnit((prev) => !prev);
  };
  
  useEffect(() => {
    fetchEmployeeKpis();
  }, [fetchEmployeeKpis]);

  // Fetch notifications from API
  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem("access-token") || localStorage.getItem("admin-access-token");
      const parsedToken = token ? JSON.parse(token) : null;
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}notifications/get`, {
        headers: {
          Authorization: `Bearer ${parsedToken?.token}`,
        },
      });
      if (res.data?.status && Array.isArray(res.data.data)) {
        setNotifications(res.data.data);
      }
    } catch (err) {
      setNotifications([]);
    }
  };

  // Fetch notifications on mount so count is always visible
  useEffect(() => {
    fetchNotifications();
    // Optionally, you can set up polling here if you want live updates
  }, []);

  useEffect(() => {
    if (showNotifications) {
      fetchNotifications();
    }
  }, [showNotifications]);

  if (isLoggedIn) {
    return (
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link
                to={
                  userData?.role === "owner"
                    ? "/admin/dashboard"
                    : "/company/dashboard"
                }
                className="logo"
                onClick={() => {
                  removeCompanyData();
                }}
              >
                {/* <h2>
                  <img src={esglogonew} alt="" />
                  ESG <span>Mitraa</span>
                </h2> */}
                {/* <h2 className="d-flex align-items-center" style={{gap: '8px', margin: 0, padding: 0}}>
                  <img
                    src={esglogonew}
                    alt="ESG Drishtii Logo"
                    style={{ width: "180px", height: "180px", objectFit: "contain", display: "block", marginRight: 0, marginBottom: 0, marginTop: "20px", background: "transparent" }}
                  />
                  {/* <span className="fw-bold fs-3" style={{lineHeight: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 0}}>
                    <span style={{color: '#fff', fontWeight: 700, fontSize: '1.7rem', letterSpacing: '0.5px'}}>ESG</span>
                    <span style={{color: '#2ecc71', fontWeight: 400, fontSize: '1rem', marginTop: '-4px', letterSpacing: '1px'}}>DRISHTII</span>
                  </span> 
                </h2> */}
                       <div style={{ width: '100%', textAlign: 'center', marginTop: '40px' }}>
  <img src={esglogonew} alt="ESGDhrishti Logo" style={{ width: '200px', height: 'auto', display: 'inline-block' }} />
</div>
              </Link>

              {/* <button
                className="btn btn-sm sidebar-toggle-button"
                onClick={() => setShowSidebar(true)}
              >
                <i className="mdi mdi-menu-left"></i>
              </button> */}
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars"></i>
            </button>

            <form className="app-search d-none  ">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                />
                <span className="bx bx-search-alt"></span>
              </div>
            </form>
          </div>

          {/* <div className=" navbar-links">
            {isLoggedIn && (
              <div className="header-links d-flex justify-content-center align-items-center">
                {headerCategory?.assignCategory &&
                  headerCategory?.assignCategory?.length > 0 &&
                  headerCategory?.assignCategory?.map((ele) => (
                    <div
                    key={ele?.id}
                    onClick={() => {
                      setCatId(ele?.catId);
                      if (ele?.catIdAssignCategory?.name === "BRSR")
                        navigate("/company/brsr");
                      else {
                        navigate("/company/dashboard");
                      }
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <h3 className={catId === ele?.catId ? "active-link" : ""}>
                      {ele?.catIdAssignCategory?.name}
                    </h3>
                  </div>
                  ))}
              </div>
            )}
          </div> */}

          <div className=" align-items-center d-flex">
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect d-flex align-items-center"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => setShowUnit(!showUnit)}
              >
                Unit
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>
              <div
                className={`dropdown-menu dropdown-menu-end ${
                  showUnit ? "show" : ""
                } `}
              >
                <div className="p-2  d-flex flex-column  gap-3">
                  <div>
                    {isLoggedIn && (
                      <>
                        <label htmlFor="unit-select" className="unit-label">
                          Select Unit:
                        </label>
                        <label
                          htmlFor="unit-select"
                          className="unit-label-mobile"
                        >
                          Select Unit:
                        </label>

                        <select
                          id="unit-select"
                          className="form-control w-100"
                          value={companyUnit}
                          onChange={handleChange}
                        >
                          <option value="">Select Unit</option>
                          {toJS(companyData)?.assignUnit?.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.name}
                            </option>
                          ))}
                        </select>
                      </>
                    )}
                  </div>
                  {toJS(userData)?.role === "company" && (
                    <div className="form-check form-switch mb-1 d-flex flex-row-reverse gap-5  justify-content-end p-0 g  ">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckChecked"
                        checked={showAll}
                        onChange={handleShowAllUnitsData}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckChecked"
                      >
                        Show all units
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Notification Icon */}
            <div className="dropdown d-inline-block ms-2" style={{position: 'relative'}}>
              <button
                type="button"
                className="btn header-item noti-icon waves-effect d-flex align-items-center"
                id="page-header-notifications-dropdown"
                aria-haspopup="true"
                aria-expanded={showNotifications}
                onClick={() => setShowNotifications((prev) => !prev)}
              >
                <i className="bx bx-bell bx-tada"></i>
                {notifications.length > 0 && (
                  <span className="badge bg-danger rounded-pill" style={{position: 'absolute', top: 2, right: 2}}>{notifications.length}</span>
                )}
              </button>
              <div
                className={`dropdown-menu dropdown-menu-end notifications-dropdown ${showNotifications ? "show" : ""}`}
                style={{ minWidth: 350, maxWidth: 400, maxHeight: 400, overflowY: "auto", wordBreak: 'break-word', whiteSpace: 'normal', right: 0, left: 'auto' }}
              >
                <div className="p-2 border-bottom fw-bold">Notifications</div>
                {notifications.length === 0 ? (
                  <div className="p-3 text-center text-muted">No notifications</div>
                ) : (
                  notifications.map((notif, idx) => (
                    <div key={notif.id || idx} className="dropdown-item d-flex justify-content-between align-items-start gap-2" style={{wordBreak: 'break-word', maxWidth: 340}}>
                      <div style={{minWidth: 0, flex: 1}}>
                        <div className="fw-bold">{notif.title || "Notification"}</div>
                        <div className="small text-muted">{notif.message || notif.body}</div>
                        {/* Debug: Log notification object to inspect unitNames */}
                        {/* {console.log('Notification object:', notif)} */}
                        {/* Render grouped details if arrays are present */}
                        {Array.isArray(notif.categoryNames) && notif.categoryNames.length > 0 &&
                          notif.categoryNames.map((cat, i) => (
                            (cat || notif.subCategoryNames[i] || notif.kpiNames[i] || notif.unitNames[i] || (notif.companyUnitNames && notif.companyUnitNames[i])) && (
                              <div key={i} style={{marginBottom: 4, paddingBottom: 2, borderBottom: '1px solid #f0f0f0'}}>
                                {cat && <div className="small text-info">Category: {cat}</div>}
                                {notif.subCategoryNames && notif.subCategoryNames[i] && <div className="small text-info">Subcategory: {notif.subCategoryNames[i]}</div>}
                                {notif.kpiNames && notif.kpiNames[i] && <div className="small text-info">KPI: {notif.kpiNames[i]}</div>}
                                {/* Always show Unit line with fallback */}
                               
                                {/* Show Company Unit line with fallback */}
                                <div className="small text-info">Company Unit: {notif.companyUnitNames && notif.companyUnitNames[i] ? notif.companyUnitNames[i] : <i>None</i>}</div>
                              </div>
                            )
                          ))
                        }
                        <div className="small text-secondary">{notif.createdAt ? new Date(notif.createdAt).toLocaleString() : ""}</div>
                      </div>
                      <button
                        className="btn btn-sm btn-link text-danger p-0 ms-2"
                        title="Delete notification"
                        style={{fontSize: '1.2rem'}}
                        onClick={async (e) => {
                          e.stopPropagation();
                          try {
                            const token = localStorage.getItem("access-token") || localStorage.getItem("admin-access-token");
                            const parsedToken = token ? JSON.parse(token) : null;
                            await axios.delete(`${process.env.REACT_APP_BASE_URL}notifications/${notif.id}`, {
                              headers: {
                                Authorization: `Bearer ${parsedToken?.token}`,
                              },
                            });
                            setNotifications((prev) => prev.filter((n) => n.id !== notif.id));
                          } catch (err) {
                            alert("Failed to delete notification");
                          }
                        }}
                      >
                        <i className="bx bx-trash"></i>
                      </button>
                    </div>
                  )) // ✅ FIXED: Added missing closing parenthesis here
                )}
              </div>
            </div>

            <div className="dropdown d-inline-block">
              <button
                type="button"
                onClick={handleProfileDropdown}
                className="btn header-item waves-effect d-flex align-items-center"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user"
                  src={user}
                  alt="Header Avatar"
                />
                <span
                  className="d-none d-xl-inline-block ms-1 text-capitalize"
                  key="t-henry"
                >
                  {userData?.firstName}
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>
              <div
                className={`dropdown-menu dropdown-menu-end ${
                  showProfile ? "show" : ""
                } position-absolute m-0`}
              >
                <Link
                  className="dropdown-item"
                  to={
                    userData?.role === "owner"
                      ? "/admin/profile"
                      : "/company/profile"
                  }
                >
                  <i className="bx bx-user font-size-16 align-middle me-1"></i>{" "}
                  <span key="t-profile">Profile</span>
                </Link>

                <div className="dropdown-divider"></div>
                <button
                  onClick={logoutHandler}
                  className="dropdown-item text-danger"
                >
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
                  <span key="t-logout">Logout</span>
                </button>
              </div>
            </div>
          </div>
          {/* right side panel trigger */}
          <div className="menu-button">
            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item noti-icon"
              id="page-header-notifications-dropdown"
              onClick={() => setShowRightSidePanel(true)}
            >
              <i className="fa fa-bars"></i>
            </button>
          </div>
        </div>

        {/* sidebar for mobile  */}
        <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)}>
          <Offcanvas.Body>
            <Sidebar />
          </Offcanvas.Body>
        </Offcanvas>

        {/* menu items responsive */}
        <Offcanvas
          placement={"start"}
          show={showRightSidePanel}
          onHide={() => setShowRightSidePanel(false)}
        >
          <Offcanvas.Body>
            {isLoggedIn && (
              <div className=" right-side-panel  vertical-menu h-100 border-0 rounded-0 mb-0 card">
                <p>Menu</p>

                <div className="header-links d-flex flex-column  ">
                  {headerCategory?.assignCategory &&
                    headerCategory?.assignCategory?.length > 0 &&
                    headerCategory?.assignCategory?.map((ele) => (
                      <div
                        key={ele?.id}
                        onClick={() => {
                          setCatId(ele?.catId);
                          // navigate("/company/dashboard");
                          //in case of mobile view
                          setShowRightSidePanel(false);
                          setShowSidebar(true);
                        }}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                        }}
                      >
                        <img
                          style={{ width: "14px", opacity: "0.8" }}
                          src={whiteLogo}
                          alt=""
                        />
                        <h3
                          style={{ marginTop: "8px" }}
                          className={catId === ele?.catId ? "active-link " : ""}
                        >
                          {ele?.catIdAssignCategory?.name}
                        </h3>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </header>
    );
  }

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          <div className="navbar-brand-box">
            <Link to="/admin/dashboard" className="logo">
              {/* <h2>
                <img src={esglogonew} alt="" />
              </h2> */}
              <div style={{ width: '100%', textAlign: 'center', marginTop: '50px' }}>
  <img src={esglogonew} alt="ESGDhrishti Logo" style={{ width: '200px', height: 'auto', marginBottom: '12px', display: 'inline-block' }} />
</div>
            </Link>
          </div>

          <button
            type="button"
            className="btn btn-sm px-3 font-size-16 header-item waves-effect"
            id="vertical-menu-btn"
          >
            <i className="fa fa-fw fa-bars"></i>
          </button>

          <form className="app-search d-none d-lg-block">
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
              />
              <span className="bx bx-search-alt"></span>
            </div>
          </form>
        </div>

        <div className="d-flex">
          <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item noti-icon waves-effect"
              id="page-header-notifications-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="bx bx-bell bx-tada"></i>
              <span className="badge bg-danger rounded-pill">3</span>
            </button>
          </div>

          <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item waves-effect"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={handleProfileDropdown}
            >
              <img
                className="rounded-circle header-profile-user"
                src={user}
                alt="Header Avatar"
              />
              <span
                className="d-none d-xl-inline-block ms-1 text-capitalize"
                key="t-henry"
              >
                Admin
              </span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>
            <div
              className={`dropdown-menu dropdown-menu-end ${
                showProfile ? "show" : ""
              } position-absolute m-0`}
            >
              <Link className="dropdown-item" to="/admin/profile">
                <i className="bx bx-user font-size-16 align-middle me-1"></i>{" "}
                <span key="t-profile">Profile</span>
              </Link>
              <Link className="dropdown-item d-block" to="/admin/dashboard">
                <span className="badge bg-success float-end">11</span>
                <i className="bx bx-wrench font-size-16 align-middle me-1"></i>{" "}
                <span key="t-settings">Settings</span>
              </Link>
              <div
                className="dropdown-item text-danger"
                onClick={logoutHandler}
                style={{ cursor: "pointer" }}
              >
                <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>{" "}
                <span key="t-logout">Logout</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default observer(Header);